import { render, staticRenderFns } from "./molecule.swatchsubgroup.vue?vue&type=template&id=6a882b68"
import script from "./molecule.swatchsubgroup.vue?vue&type=script&lang=ts"
export * from "./molecule.swatchsubgroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports